




import store from '@/store';
export default
  name: 'ErrorLabel'

  props:
    # Props名
    name:
      type: String
      default: ''
    # GROUP
    group:
      type: String
      default: null
    # コントロール配列
    index:
      type: Number
      default: null
  computed: {
    getApiData: () ->
      try
        errors = store.getters.errors
        if errors
          if @group
            if errors[@group]
              if @index >= 0
                if errors[@group][@index][@name]
                  return errors[@group][@index][@name][0]
              else
                if errors[@group][@name]
                  return errors[@group][@name][0]
          else if errors[@name]
            return errors[@name][0]
      catch e
      return ''
  }
